import React from "react";
import "./ExpansionSection.css";
import expansionImg from "../../media/expansionimg.jpg";

const ExpansionSection = () => {
  return (
    <section className="expansion-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-md-6 expansion-image-col">
            <img
              src={expansionImg}
              alt="Service Area Expansion"
              className="expansion-image img-fluid rounded"
            />
          </div>

          {/* Right Content */}
          <div className="col-md-6 expansion-content-col">
            <span className="expansion-subtitle text-uppercase">
              Service Area & Expansion
            </span>
            <h2 className="expansion-title mt-2 mb-3">
              Expanding Our Reach Nationwide
            </h2>
            <p className="expansion-text">
              Aspen SR Business Solutions proudly serves clients throughout the
              Denver metro area and greater Colorado region. As we continue to
              grow, our vision is to expand across the United States—bringing
              our trusted, people-first financial services to clients
              nationwide. No matter your location, we're committed to providing
              responsive, ethical, and forward-thinking solutions that help your
              organization thrive.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpansionSection;
